import React, { useEffect, useState } from 'react';
import { Route, Switch } from 'react-router-dom';
import instance from 'helpers/AuthComponent';
import axios from 'axios';
import { updateSettings } from 'store/Actions/Lists/ListActions';
import { store } from 'store/Store';
import { snackbarError } from 'store/Actions/UI/SnackbarActions';
import ThemeSwitcher from 'react-css-vars';
import smoothscroll from 'smoothscroll-polyfill';
import Template from './components/Templates';
import Preview from './components/Preview/Preview';
import './helpers/AuthComponent';
import './App.css';

function App() {
  const [settings, setSettings] = useState({});

  useEffect(() => {
    smoothscroll.polyfill();
    axios
      .get(instance.settingsURL)
      .then((res) => {
        store.dispatch(updateSettings(res.data));
      })
      .catch(() => {
        store.dispatch(snackbarError('Some error occured'));
      });
  }, []);

  store.subscribe(() => {
    setSettings(store.getState().list.settings);
  });

  return (
    <ThemeSwitcher theme={settings}>
      {Object.keys(settings).length > 1 ? (

        <Switch>
          <Route
            exact
            path={`/${settings.templateuri}`}
            render={(props) => <Preview {...props} />}
          />
          <Route
            path="/"
            render={(props) => (
              <Template
                {...props}
                settings={settings}
              />
            )}
          />
        </Switch>
      ) : (
        ''
      )}
    </ThemeSwitcher>
  );
}

export default App;
